export type CurrencyLike = {
  code: string;
  name?: string;
  symbol?: string | null;
};

export function isUsdCurrency(currency: CurrencyLike | null | undefined): boolean {
  return currency?.code?.trim().toUpperCase() === 'USD';
}

/** Currencies that can have exchange rates (USD is the base — excluded). Only active currencies. */
export function listRateCurrencies<T extends CurrencyLike & { isActive?: boolean }>(currencies: T[]): T[] {
  return currencies.filter((c) => !isUsdCurrency(c) && c.isActive !== false);
}

/** Display as CODE (Symbol), e.g. EUR (€). Falls back to code only when symbol is missing. */
export function formatCurrencyCodeSymbol(
  currency: CurrencyLike | null | undefined,
  fallback?: string | number,
): string {
  if (!currency?.code) {
    return fallback != null ? String(fallback) : '—';
  }
  const symbol = currency.symbol?.trim();
  return symbol ? `${currency.code} (${symbol})` : currency.code;
}
